import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Created <b><a href="https://intager.com" target="_blank">Intager DEV Team</a></b> 2020 -
    </span>
  `,
})
export class FooterComponent {
}
